exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".index_magicBanner_X0HLS {\n  width: 100%;\n  margin: 0 auto;\n  position: relative;\n  text-align: center;\n  overflow: hidden;\n  font-size: 0;\n  display: flex;\n  justify-content: center;\n}\n\n.index_magicBanner_X0HLS .index_banner_2c_k1 {\n  position: relative;\n}\n\n.index_magicBanner_X0HLS .index_banner_2c_k1 img.index_background_1NvPZ {\n  width: 100%;\n  height: 100%;\n}\n\n.index_magicBanner_X0HLS .index_banner_2c_k1 .index_clickAbleArea_35VkP {\n  display: block;\n  position: absolute;\n  z-index: 1;\n}\n", ""]);

// Exports
exports.locals = {
	"magicBanner": "index_magicBanner_X0HLS",
	"banner": "index_banner_2c_k1",
	"background": "index_background_1NvPZ",
	"clickAbleArea": "index_clickAbleArea_35VkP"
};